import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { initializeAnalytics } from '../../utils/analytics';
import Cookies from 'universal-cookie';
import '../../css/cookie.css';

const cookies = new Cookies();

const CookieConsent = () => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const consent = cookies.get('cookieConsent');
        if (consent !== undefined) {
            setVisible(false);
        }
    }, []);

    const handleAccept = () => {
        cookies.set('cookieConsent', 'true', { path: '/', maxAge: 31536000 }); // 1 year expiration
        initializeAnalytics();
        setVisible(false);
    };

    const handleDecline = () => {
        cookies.set('cookieConsent', 'false', { path: '/', maxAge: 31536000 }); // 1 year expiration
        cookies.remove('_ga');
        cookies.remove('_ga_TT0D9NCLMY');
        cookies.remove('_gid');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookieConsent">
            <p className="gird-item">Mes naudojame slapukus, kad užtikrintume geriausią patirtį mūsų svetainėje.
                Tęsdami naudotis mūsų svetaine, jūs sutinkate su mūsų slapukų naudojimu. <br />
                Jūsų pasirinkimas bus išsaugotas jūsų naršyklėje, Sužinokite daugiau mūsų<Link to="/privatumas" className="logo">Privatumo Politikoje.</Link>
            </p>
            <div className="gird-item">
                <button onClick={handleAccept}>Sutinku</button>
                <button onClick={handleDecline}>Atsisakau</button>
            </div>
        </div>
    );
};

export default CookieConsent;